<template>
    <div class="consultaion">
        <div>
            <div class="box-style">
                <div class="list_new_title">{{title}}</div>
                <p class="list-date">{{createDate}}</p>
                <div class="list-left" v-html="content">
                    {{content}}
                </div>
            </div>
            <!-- <div class="list-left-bottom">
                <span @click="upArticleId" v-if="upArticle">上一篇：{{upArticle}}</span>
                <span @click="downArticleId" style="text-align:right" v-if="downArticle">下一篇：{{downArticle}}</span>
            </div> -->
        </div>
        <div class="list-right">
            <div class="list-right-top">
                <div class="list-title">
                    <span>相关推荐</span>
                </div>
                <ul class="list-right-ul">
                    <li v-for="(item,index) in messageList" :key="index" @click="updataRecommend(item.id,index)">
                        <span class="li-square"></span>
                        <span :style="{color:currentIndex==index?'rgba(16,16,16,1)':'rgba(16,16,16,0.7)'}">{{item.title}}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import merge from 'webpack-merge';
    import {_turningArticle} from '@/api/consultation'

    export default {
        metaInfo() {
            return {
                title: this.title + '|时尚知识产权保护平台',
                meta: [{                 // set meta
                    name: 'keyWords',
                    content: ''
                }, {
                    name: 'Description',
                    content: ''
                }]
            }
        },
        name: "consultationInfo",
        data() {
            return {
                content: "",
                messageList: [],
                upArticle: "",
                upArticleIds: "",
                downArticle: "",
                downArticleIds: "",
                title: "",
                currentIndex:null,
                createDate:""
            }
        },
        methods: {
            getArticles(id) {
                // console.log(this.$route)
                this.getRequest('/cmsArticle/getArticle/' + id).then(res => {
                    if (res.code == 200) {
                        this.title = res.result.title;
                        this.content = res.result.content.content;
                        this.messageList = res.result.recommends;
                        this.upArticle = res.result.upArticle && res.result.upArticle.title;
                        this.upArticleIds = res.result.upArticle && res.result.upArticle.id;
                        this.downArticle = res.result.downArticle && res.result.downArticle.title;
                        this.downArticleIds = res.result.downArticle && res.result.downArticle.id;
                        this.createDate=res.result.createDate&&res.result.createDate;

                        this.turningArticle(id)

                    }
                })
            },
            // 更新页面
            // updatePages(val){
            //   this.$router.push({query:merge(this.$route.query,{'newPage':val})})
            //   // console.log(this.$route)
            //   const newId = this.$route.query.newPage;
            //   this.getArticles(newId);
            // },
            //相关推荐
            updataRecommend(val,index) {
                //  this.updatePages(val)
                this.getArticles(val)
                this.currentIndex=index
            },
            //上一篇
            upArticleId() {
                // this.updatePages(this.upArticleIds)
                this.getArticles(this.upArticleIds)
            },
            //下一篇
            downArticleId() {
                this.getArticles(this.downArticleIds)
                // this.updatePages(this.downArticleIds)
            },

            //上下篇数据文章标题获取
            turningArticle(id) {
                let data = {
                    id: id,
                    type: 'down'
                }
                _turningArticle(data).then(res => {
                  console.log(res);
                })
            }

        },
        watch: {
            $route(to, from) {
                console.log('+++++++++++++++++++++', to, from)
                this.getArticles(this.$route.params.id);
            }
        },
        mounted() {
            console.log(this.$route.params)
            if (this.$route.query.newPage) {
                this.getArticles(this.$route.query.newPage);
            } else {
                this.getArticles(this.$route.params.id);
            }
        },
    };
</script>

<style scoped lang="less">
    .consultaion {
        width: 1334px;
        display: flex;
        justify-content: center;
        margin: 10px auto 50px;
        .box-style{
            width:750px;
            margin-right: 90px;
        }
        .list_new_title {
            width: 730px;
            margin:0 auto;
            text-align: left;
            padding-top:62px;
            font-size:42px;
            font-weight:400;
            color:rgba(16,16,16,1);
            line-height:58px;
        }
        .list-date{
            font-size:16px;
            font-weight:400;
            color:rgba(138,138,138,1);
            margin:15px 0 30px;
        }

        .list-left {
            width: 749px;
            min-height: 400px;
            margin:0 auto 20px;
            /deep/ img {
                max-width: 749px !important;
                margin: 0 auto;
                display: flex;
            }
            // /deep/ p {
            //   font-size: 16px;
            //   color: #666;
            // }
            // /deep/ span {
            //   font-size: 16px;
            //   color: #666;
            // }
        }

        .list-left-bottom {
            width: 890px;
            height: 72px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 2px 40px 0px rgba(29, 31, 108, 0.04);
            border-radius: 2px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            span {
                font-size: 16px;
                color: rgba(102, 102, 102, 1);
                margin: 0px 30px;
                display: inline-block;
                width: 385px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                cursor: pointer;
            }
        }

        .list-right {
            width: 344px;
            height: 835px;
            padding-top:50px;
            .list-right-top {
                width: 344px;
                height: 613px;
                .list-title {
                    width: 344px;
                    font-size:24px;
                    font-weight:400;
                    color:rgba(16,16,16,1);
                    margin-bottom: 51px;
                }

                .list-right-ul {
                    overflow: hidden;
                    height: 435px;

                    li {
                        list-style: none;
                        width: 344px;
                        cursor: pointer;
                        display: flex;
                        justify-content: flex-start;
                        align-items: flex-start;
                        margin-bottom: 46px;
                        .li-square{
                            display: inline-block;
                            width:8px;
                            height:8px;
                            background:rgba(18,18,16,1);
                            margin-right: 10px;
                            position: relative;
                            top:7px;
                        }
                        span {
                            width: 332px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                            font-size: 16px;
                            color:rgba(16,16,16,0.8);
                            line-height:24px;
                        }
                    }
                }
            }
        }
    }
</style>
